import {prettifyTaxonomia} from '@/lib/bateria'

export function TituloDimension({dominio, dimension}: {dominio?: string | null; dimension: string}) {
  return (
    <p className="mb-1.5 font-mono text-[11px] font-medium tracking-wider text-muted-foreground uppercase">
      {dominio && <span className="text-muted-foreground/60">{prettifyTaxonomia(dominio)} · </span>}
      {prettifyTaxonomia(dimension)}
    </p>
  )
}
